import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import AssetImage from './AssetImage';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import {ASSET_CONFIG} from '../../../models/dialogModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class SecondaryLibraryImage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,

            image: {},
            screenStatus:"",
            continue_label: appHelper.getLocaleString("continue_label"),
            credit_label: appHelper.getLocaleString("credit_label")

        };
        this.getAssets = this.getAssets.bind(this);
        this.show = this.show.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
    }

    componentDidMount() {
        this.getAssets();
    }



    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                continue_label: appHelper.getLocaleString("continue_label"),
                credit_label: appHelper.getLocaleString("credit_label")
            });
        }
    }

    componentDidUpdate(){

    }


    getAssets() {
        let image = appHelper.getLibraryImageAsset(this.state.screenObject);
        this.setState({image: image});

    }

    show() {
        let fileRef = this.refs[`image_${this.state.screenObject.id}`];
        if (appHelper.isDefined(fileRef)) {
            TweenLite.set(fileRef, {opacity: 1, height: "auto"});
            TweenLite.from(fileRef, 0, {
                height: 0,
                opacity: 0,
                ease: Expo.easeInOut
            });
        }
    }




    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }


    render() {
        return (

            <div className="object-container" ref={`image_${this.state.screenObject.id}`} >
                <div className={`library-image`}>
                    <div className="img-container">
                        <img src={this.getImagePath(this.state.image.src)} alt="" id={appHelper.isDefined(this.props.id) ? this.props.id : `image_file_${this.state.screenObject.id}`}/>
                    </div>
                    {appHelper.isDefined(this.state.image.credit) && this.state.image.credit.length > 0 &&
                        <div className="image-credit center"  style={this.state.imageStyles}>{this.state.cedit_label}: {this.state.image.credit}</div>
                    }
                </div>
                {this.state.showProgressionButton
                    ? <Button label={this.state.continue_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>

        );
    }
}

SecondaryLibraryImage.propTypes = {
    screenObject: PropTypes.object.isRequired,
    id:PropTypes.string,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

SecondaryLibraryImage.contextTypes = {
    router: PropTypes.object
};


function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryLibraryImage);



/** WEBPACK FOOTER **
 ** ./src/components/objects/image/SecondaryLibraryImage.js
 **/